import type Phaser from 'phaser';

// DOM notices over the canvas (crisp text, native layout). 'toast': a line at
// the top for a few seconds, the game keeps running. 'overlay': covers the
// game until it is replaced or hidden. An empty text hides whatever shows.
export type NoticeMode = 'toast' | 'overlay';

// Wires `game.events.emit(eventName, text, mode?, ms?)` to a #notice-style
// element holding a .box child.
export function installNotices(game: Phaser.Game, notice: HTMLElement, eventName: string): void {
  const box = notice.querySelector('.box') ?? notice;
  let timer: ReturnType<typeof setTimeout> | null = null;
  game.events.on(eventName, (text: string, mode: NoticeMode = 'toast', ms = 12_000) => {
    if (timer) clearTimeout(timer);
    timer = null;
    if (!text) {
      notice.hidden = true;
      return;
    }
    box.textContent = text;
    notice.className = mode;
    notice.hidden = false;
    if (mode === 'toast') timer = setTimeout(() => (notice.hidden = true), ms);
  });
}
